<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title Thêm mới giáo án - Lý thuyết
        .clearfix
      div.box-content
        .box-item(v-if="lstLessonChooses && lstLessonChooses !== null" v-for="(itemLesson, index) in lstLessonChooses")
          .item-remove(@click="removeBoxItem(itemLesson)")
            img(:src="require('../../../assets/images/theory/delete-24px.svg')")
          .box-item-child
            .item-img
              img(:src="itemLesson.banner[0]" v-if="itemLesson.banner && itemLesson.banner !== null && itemLesson.banner.length > 0")
              img(:src="require('../../../assets/images/cover.jpeg')" v-else)
            .item-info
              .info-title {{itemLesson.name}}
              .info-categories.desktop Danh mục: {{itemLesson.category.name}}
              .info-grades.desktop Khối lớp: {{getGrades(itemLesson.grade)}}
          .info-categories.mobile Danh mục: {{itemLesson.category.name}}
          .info-grades.mobile Khối lớp: {{getGrades(itemLesson.grade)}}
        .box-item-form(v-if="isFormShow")
          .row
            .col-md-6
              .form-group.inline-row(:class="[countForm > 1  || (isAddItem && key_cate === 0) ? 'error' : '']")
                label.control-label Danh mục bài học *
                //- Select2.form-control(:options="categories" :settings="settingSelect2" @change="onChangeCategories($event)")
                select.form-control(@change="onChangeCategories($event)")
                  option(value="0" :selected="key_cate === 0") Chọn
                  option(v-if="categories !== null" v-for="cate in categories" :value="cate.id" :selected="cate.id === key_cate") {{cate.text}} 
            .col-md-6
              //- .form-group.inline-row(:class="[countForm > 1  || (isAddItem && key_grade === 0) ? 'error' : '']")
              .form-group.inline-row()
                label.control-label Chọn khối lớp
                //- Select2.form-control(:options="grades" :settings="settingSelect2" @change="onChangeGrades($event)")
                select.form-control(@change="onChangeGrades")
                  option(value="0" :selected="key_grade === 0") Chọn
                  option(v-if="grades !== null" v-for="item in grades" :value="item.id" :selected="item.id === key_grade") {{item.text}} 
          .row
            .col-md-12
              .form-group.inline-row.custom-select2(:class="[countForm > 1  || (isAddItem && key_lesson === 0) ? 'error' : '']")
                label.control-label Chọn lý thuyết *
                Select2.form-control(:options="lessons" :settings="settingSelect2" @select="onChangeEvent($event)" :key="key_increment_lesson")
              .form-group.inline-row(:class="[(countForm > 1  || (isAddItem && (key_cate === 0 || key_lesson === 0)) )? 'error' : '']")
                label.control-label.required
                span.required Vui lòng điền đầy đủ thông tin
          .row
            .col-md-12
              .form-group.inline-row.last-child
                label.control-label
                button.active(@click="addBoxItem") Thêm mới
                button(@click="cancelForm") Huỷ yêu cầu
        a.action-form(@click="showForm" v-if="countForm === 0") + Thêm lý thuyết
        a.action-form(v-else) + Thêm lý thuyết
        .box-share
          .item-share-header CHIA SẺ LÝ THUYẾT *
          .item-share-content
            .item-checkbox
              input(type="checkbox" name="public_all" id="public_all" disabled :checked="isPublicSystem")
              label(for="public_all")
              span Lưu bài tập và cho phép học sinh trong toàn hệ thống tìm kiếm được để mua đáp án
            .clearfix
            .item-checkbox
              input(type="checkbox" name="public_pc" id="public_pc"  @click="onCheckSave($event, 2)")
              label(for="public_pc")
              span Lưu bài tập riêng tư (chỉ cho hiển thị trong cộng đồng và lớp học của tôi)
            .clearfix
            .box-left(v-if="isPublicPC")
              .row.row-share-class
                .col-md-6
                  .form-group
                    select#class_id.form-control(@change="onChangeSelect($event)" :key="increment_class")
                      option(value='0' selected) Chọn lớp học bạn muốn chia sẻ trong PC
                      option(v-for='o in classes' :value='o.id') {{o.name}}
              .row.row-class
                .col-md-12
                  .box-item-attach(v-if="item" v-for="(item, index) in lstClassAdded")
                    label
                      .attach-left
                        img(src="../../../assets/images/theory/ic_class.png")
                        span {{item.name}}
                      .attach-right
                        span Hẹn thời gian
                        dateTimePicker.datetimepicker(:inline="false" :id="'datePicker_' + item.id" @onChange="changeDate($event, item)" :key="item.increment" :value="item.start_date" :minDate="false" :maxDate="false" :locale="'en'")
                      .clearfix
                      span.material-icons.remove(@click='deleteClass(item)' style='cursor: pointer;') delete
                      .clearfix
        .box-footer
          button.submit(@click="submitForm") Thêm mới
          button.cancel(@click="returnList()") Huỷ yêu cầu

</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import dateTimePicker from '@/core/components/mdDateTimePicker'
import $ from 'jquery'
export default {
  components: {
    MdNotification,
    dateTimePicker
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      limit: 10,
      offset: 0,
      key_cate: 0,
      key_grade: 0,
      key_lesson: 0,
      key_selected: 'Tìm theo tên',
      key_increment_lesson: 0,
      lstPC: [],
      classes: [],
      grades: [],
      categories: [],
      lessons: [],
      lstLessonsAll: [],
      lstLessonChooses: [],
      lstClassAdded: [],
      countForm: 0,
      isFormShow: false,
      isAddItem: false,
      isPublicPC: false,
      isPublicSystem: true,
      increment_class: 0,
      loader: null,
      format: 'DD/MM/YYYY hh:mm',
      settingSelect2: {
        escapeMarkup: this.buildInputSelect2,
        templateResult: this.formatFunction,
        containerCssClass: 'custom-container',
        dropdownCssClass: 'custom-dropdown'
      }
    }
  },
  watch: {
    '$route': function(from, to) {
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.3,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    buildInputSelect2() {
      var html = $(
        '<style>' +
          '@media (max-width: 1200px){.select2-container{width:100% !important;}}' +
          '.nav-open .select2-container{width:100% !important;}' +
          '.select2-container{margin-top: 0 !important;}' +
          '.select2-container .select2-selection--single{border-radius:10px !important;height:32px !important;}' +
          '.select2-container--default .select2-selection--single .select2-selection__arrow{display:none;}' +
          '.select2-selection__rendered{height: 100%; display:flex !important;}' +
          '.select2-selection__rendered span{display:block; width:100%;color: #B4B4B4; font-size:14px;align-items: center; display: inline-flex;}' +
          '.select2-selection__rendered span.results-message{display:none;}' +
          '.select2-results__message span.placeholder{display:none;}' +
          '.select2-results__message span.results-message{display:block;padding: 0 16px 16px;}' +
          '.custom-dropdown .select2-search{margin: 16px;padding:0;position: relative;}' +
          '.select2-search--dropdown .select2-search__field, .custom-dropdown .select2-search__field{background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #838F9F;border-radius: 10px !important; padding-left:10px; }' +
          '.custom-dropdown .select2-search:after{content: "" ; color: #2759AE; background: url("' + require('../../../assets/images/faces/search.svg') + '") 0 0 no-repeat;height: 16px; position: absolute; right: 12px; top: 8px; width: 16px;}' +
          '.select2-results__option{padding: 6px 0;}' +
          '.select2-container--open .select2-dropdown{background: #F2F2F2 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;border-radius: 10px;}' +
        '</style>' +
        '<span class="placeholder">' + this.key_selected + '</span>' +
        '<span class="results-message">Không có dữ liệu</span>'
        )
      return html
    },
    formatFunction(item) {
      var html = $(
        '<style>' +
          '.select2-dropdown{background: #F2F2F2 0% 0% no-repeat padding-box;}' +
          '.custom-dropdown{background: #F2F2F2 0% 0% no-repeat padding-box;box-shadow: 0px 3px 6px #00000029;border-radius: 10px !important; padding: 15px 0;} ' +
          '.custom-dropdown .select2-search{margin: 0 16px 16px;padding:0;position: relative;}' +
          '.select2-search--dropdown .select2-search__field, .custom-dropdown .select2-search__field{background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #838F9F;border-radius: 10px !important; padding-left:10px; }' +
          '.custom-dropdown .select2-search:after{content: "" ; background: url("' + require('../../../assets/images/faces/search.svg') + '") 0 0 no-repeat;height: 16px; position: absolute; right: 12px; top: 8px; width: 16px;}' +
          '.select2-results__option--highlighted .item-filter span {color:#fff !important;}' +
          '.select2-container--default .select2-results .select2-results__options {max-height: 300px;overflow-y: auto;}' +
          '.item-filter{display:flex;}' +
          '.item-filter-info{width: calc(100% - 50px); margin-left: 10px;}' +
          '.item-filter:hover span {color:#fff !important;}' +
          '.item-filter-info span{font-size:15px; display:block;color: #333333;margin-bottom:4px; text-align: left;}' +
          '.item-filter-info span.last{color: #969FAD; font-size:13px; display:block;}' +
          'svg {color: blue;}' +
        '</style>' +
        '<div class="item-filter">' +
        '<div class="item-filter-info"><span>' + item.text + '</span></div>' +
        '</div>')
      return html
    },
    async submitForm() {
      if (this.lstLessonChooses.length === 0) {
        this.showNotification('Bạn chưa chọn lý thuyết', 'warning', 'top', 'right', 7000)
      } else if (!this.isPublicPC && !this.isPublicSystem) {
        this.showNotification('Bạn chưa chọn chia sẽ lý thuyết', 'warning', 'top', 'right', 7000)
      } else if (this.isPublicPC && this.lstClassAdded.length === 0) {
        this.showNotification('Bạn chưa chọn lớp học để chia sẻ trong PC', 'warning', 'top', 'right', 7000)
      } else {
        // submit giao án
        if (this.lstLessonChooses.length > 0) {
          this.show()
          for (let index = 0; index < this.lstLessonChooses.length; index++) {
            const elLesson = this.lstLessonChooses[index]
            var objInputLesson = {}
            var objInput = {
              lesson_id: elLesson.id
            }
            // if (this.isPublicSystem) {
            //   // public toàn hệ thống
            //   objInputLesson = Object.assign(objInputLesson, {is_public: 2})
            // }
            objInputLesson = Object.assign(objInputLesson, {is_public: 2})
            if (this.isPublicPC && this.lstClassAdded.length > 0) {
              for (let index = 0; index < this.lstClassAdded.length; index++) {
                const elClass = this.lstClassAdded[index]
                objInput = Object.assign(objInput, {class_id: elClass.id})
                objInput = Object.assign(objInput, {start_date: elClass.start_date})
                var result = await this.checkLessonClass(elLesson.id, elClass.id)
                // chuyển đổi timestamptz
                let tzDate = new Date(elClass.key_date).toISOString()
                // console.log(tzDate, typeof tzDate)
                if (result === 0) {
                  // tạo mới giáo án lý thuyết
                  objInput = Object.assign(objInput, {start_date: tzDate})
                  await this.createLessonClass(objInput)
                } else {
                  // cập nhật lại thời gian
                  var $objWhere = {
                    lesson_id: {_eq: elLesson.id},
                    class_id: {_eq: elClass.id}
                  }
                  var $objInput = {
                    start_date: tzDate
                  }
                  await this.updateLessonClass($objWhere, $objInput)
                }
              }
              // public trong pc
              objInputLesson = Object.assign(objInputLesson, {is_public_pc: 2})
            }
            // cập nhật lại lesson
            if (Object.keys(objInputLesson).length > 0) {
              await this.updateLesson(objInputLesson, {id: {'_eq': elLesson.id}})
            }
            this.showNotification('Thêm giáo án lý thuyết thành công', 'success', 'top', 'right', 2000)
            this.$router.push({name: 'lesson_planning_lesson', query: {id: this.lstPC.id}})
          }
          this.loader.hide()
        }
      }
    },
    async checkLessonClass(lessonID, classID) {
      var variables = {
        where: {
          lesson_id: {_eq: lessonID},
          class_id: {_eq: classID}
        }
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_LESSON_CLASS),
        fetchPolicy: 'no-cache',
        variables: variables
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
      return data.lesson_class.length
    },
    async updateLesson($objInput, $objWhere) {
      var variables = {
        objInput: $objInput,
        objWhere: $objWhere
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_LESSON_PLANNING),
        variables: variables
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
    },
    async createLessonClass($objInput) {
      var variables = {
        objInput: $objInput
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.CREATE_LESSON_CLASSES),
        variables: variables
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
    },
    async updateLessonClass($objWhere, $objInput) {
      var variables = {
        objWhere: $objWhere,
        objInput: $objInput
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_LESSON_CLASSES),
        fetchPolicy: 'no-cache',
        variables: variables,
        update: (store, { data: { update_lesson_class } }) => {
        }
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      })
    },
    returnList() {
      this.$router.push({name: 'lesson_planning_lesson', query: {id: this.lstPC.id}})
    },
    changeDate($event, item) {
      var index = this.lstClassAdded.findIndex(obj => Number(obj.id) === Number(item.id))
      if (this.lstClassAdded[index].start_date === undefined) this.lstClassAdded[index].start_date = this.$mycontroller.getNowDateNotSecond('/', $event)
      this.lstClassAdded[index].key_date = $event
    },
    onChangeSelect($event) {
      var item = this.classes.filter(obj => Number(obj.id) === Number($event.target.value))
      if (Object.entries(item).length > 0) {
        for (let index = 0; index < item.length; index++) {
          const element = item[index]
          if (element.start_date === undefined) {
            element.start_date = this.$mycontroller.getNowDateNotSecond('/')
            element.key_date = new Date()
          }
          element.increment = 0
          this.lstClassAdded.push(element)
          this.classes.splice(this.classes.findIndex(a => Number(a.id) === Number($event.target.value)), 1)
        }
      }
      this.increment_class++
    },
    deleteClass(item) {
      this.lstClassAdded = this.lstClassAdded.filter(obj => Number(obj.id) !== item.id)
      this.classes.push(item)
    },
    removeBoxItem(item) {
      this.lstLessonChooses = this.lstLessonChooses.filter(obj => Number(obj.id) !== item.id)
    },
    showForm() {
      this.isFormShow = true
      this.countForm++
    },
    cancelForm() {
      this.key_cate = 0
      this.key_grade = 0
      this.key_lesson = 0
      this.lessons = []
      this.grades = []
      this.isFormShow = false
      this.isAddItem = false
      this.countForm = 0
      this.key_selected = 'Tìm theo tên'
    },
    addBoxItem() {
      this.isAddItem = true
      // check bài đã tồn tại chưa
      if (this.key_cate > 0 && this.key_lesson > 0) {
        this.isAddItem = false
        this.key_selected = 'Tìm theo tên'
        var item = this.lstLessonsAll.filter(obj => Number(obj.id) === Number(this.key_lesson))
        if (Object.entries(item).length > 0) {
          for (let index = 0; index < item.length; index++) {
            const element = item[index]
            this.lstLessonChooses.push(element)
          }
        }
        this.cancelForm()
      }
    },
    onCheckSave($event, index) {
      if (index === 1) {
        // this.isPublicSystem = $event.target.checked
      } else if (index === 2) {
        this.isPublicPC = $event.target.checked
        this.clearInfoPublic()
      }
    },
    clearInfoPublic() {
      if (!this.isPublicPC) {
        this.lstClassAdded = []
      }
    },
    onChangeCategories($event) {
      this.key_grade = 0
      this.key_lesson = 0
      this.lessons = []
      this.key_cate = $event.target.value
      this.getGradeAndLesson()
    },
    onChangeGrades($event) {
      this.key_lesson = 0
      this.key_grade = $event.target.value
      this.getLessonToGrade()
    },
    getGrades(lstGrades) {
      if (lstGrades && lstGrades !== null) {
        if (Array.isArray(lstGrades)) {
          var arrGrades = []
          for (let index = 0; index < lstGrades.length; index++) {
            const element = lstGrades[index]
            arrGrades.push(element.name)
          }
          return arrGrades.join()
        } else return lstGrades.name
      }
    },
    getGradesFromLesson() {
      this.key_grade = 0
      this.grades = []
      if (this.lstLessonsAll !== null && this.key_cate > 0) {
        for (let index = 0; index < this.lstLessonsAll.length; index++) {
          const element = this.lstLessonsAll[index]
          var returnData = this.grades.filter(obj => obj.id === element.grade.id)
          if (Number(element.category_id) === Number(this.key_cate) && !Object.entries(returnData).length) {
            this.grades.push({id: element.grade.id, text: element.grade.name})
          }
        }
        this.getLessonToGrade()
      }
    },
    getLessonToGrade() {
      this.lessons = []
      var returnData = this.lstLessonsAll.filter(obj => Number(obj.category_id) === Number(this.key_cate))
      if (this.key_grade > 0) returnData = this.lstLessonsAll.filter(obj => Number(obj.category_id) === Number(this.key_cate) && Number(obj.grade_id) === Number(this.key_grade))
      if (Object.entries(returnData).length > 0) {
        for (let index = 0; index < returnData.length; index++) {
          const obj = returnData[index]
          // loại ra những lesson đã chọn
          var item = this.lstLessonChooses.filter(a => Number(a.id) === obj.id)
          if (Object.entries(item).length === 0) {
            this.lessons.push({id: obj.id, text: obj.name})
          }
        }
      }
    },
    onChangeEvent($event) {
      this.key_selected = $event.text
      this.key_lesson = Number($event.id)
      this.key_increment_lesson++
    },
    async getGradeAndLesson() {
      if (this.key_cate > 0) {
        var objWhere = {
          teacher_id: {_eq: this.$store.getters.user},
          type_lesson: {_eq: 1},
          is_delete: {_eq: false},
          category_id: {_eq: this.key_cate}
        }
        var variables = {
          where: objWhere,
          orderBy: {updated_at: 'desc'}
        }
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_GRADES_OF_USER),
          fetchPolicy: 'no-cache',
          variables: variables
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
          console.error(error.message)
        })
        if (data && data !== null && data.lesson !== null) {
          // lấy tất cả bài lý thuyết
          this.lstLessonsAll = data.lesson
          this.getGradesFromLesson()
        }
      }
    }
  },
  apollo: {
    lstPC: {
      query: gql(graphql.GET_PC_OF_USER),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          where: {
            user_id: {_eq: this.$store.getters.user},
            id: {_eq: this.$route.query.id}
          }
        }
      },
      update: data => {
        return data.private_community[0]
      }
    },
    categories: {
      query: gql(graphql.GET_CATEGORIES_OF_USER),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          where: {
            created_by: {_eq: this.$store.getters.user},
            is_deleted: {_eq: false}
          },
          orderBy: {name: 'asc'}
        }
      },
      update: data => {
        // xử lý select2 danh mục
        if (data.category !== null) {
          var lstCategories = []
          for (let index = 0; index < data.category.length; index++) {
            const element = data.category[index]
            lstCategories.push({id: element.id, text: element.name})
          }
          return lstCategories
        }
      }
    },
    classes: {
      query: gql(graphql.GET_CLASSES_OF_PC),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          where: {
            pc_id: {_eq: this.$route.query.id},
            is_delete: {_eq: false}
          }
        }
      },
      update: data => {
        return data.classes
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.box_header {
  label.title{ text-align: left; font-size:20px;  font-weight:bold;font-family: 'adobe-clean', sans-serif; letter-spacing: 0px;color: #5F6468;display:inline-block}
}
.box-content{margin-top: 15px;
  .box-item{background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; border-radius: 10px; margin-bottom: 10px; padding: 15px; position: relative;
    .item-remove{position: absolute; top: 10px; right: 10px; cursor: pointer;}
    .box-item-child{display: flex; width: 100%;
      .item-img{background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029; border-radius: 10px; width: 131px; height: 74px; text-align: center; overflow: hidden;
        img{max-width: 100%; max-height: 100%; border-radius: 10px;}
      }
      .item-info{ margin-left: 10px;font-size: 15px; color: #333333;
        .info-title{font-weight: bold;margin-bottom: 5px;}
        .info-categories{margin-bottom: 5px;
          &.mobile{display: none;}
          &.desktop{display: block;}
        }
        .info-grades{
          &.desktop{display: block;}
        }
      }
    }
    .info-categories{
      &.mobile{display: none;}
    }
    .info-grades{
      &.mobile{display: none;}
    }
  }
  .box-item-form{ padding: 15px; background: #fff;box-shadow: 0px 1px 2px #00000029;border-radius: 10px; margin-bottom: 16px;
    .inline-row{margin: 0;
      .control-label{display: inline-block; width: 125px;color: #333333; font-weight: bold; font-size: 13px;}
      .form-control{display: inline-block; width: calc(100% - 125px); height: 32px;}
      .required{display: none;}
      button{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #FFD311; border-radius: 5px;width: 160px; height: 32px; color: #23180A; font-size: 14px; margin-left: 30px;
        &.active{background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px; margin-left: 0;}
      }
      &.error{
        .form-control{ border: 1px solid #f00;}
        .custom-container{border: 1px solid #f00;}
        .required{display: inline-block; color: #f00;}
      }
      &.custom-select2{ 
        .form-control{ border: 0 none; padding: 0 !important;
          select{width: 100%;height: 32px; border-radius: 10px !important;}
        }
      }
      &.last-child{padding: 0;}
    }
  }
  .action-form{color: #1A0DAB; font-size: 13px; cursor: pointer; text-decoration: underline;}
  .box-share{ margin-top: 24px;
    .item-share-header{color: #9F6A28; text-transform: uppercase; font-size: 17px; font-weight: bold; margin-bottom: 10px;}
    .item-share-content{padding: 15px; background: #fff;box-shadow: 0px 1px 2px #00000029; border-radius: 10px;
      .item-checkbox{ display:inline-flex;  justify-content: center; align-items: center;  padding: 7px 0;
        span {margin-left: 8px; font-size: 15px; color: #343A40;}
        input{display:none;}
        input + label{cursor: pointer;background: url("../../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block; background-size: cover; margin: 0;}
        input:checked + label{cursor: pointer;background: url("../../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;display:inline-block;background-size: cover;}
      }
      .box-left {padding-left: 30px;
        .row-share-class {
          .form-group {margin-top: 0;
            .form-control {margin-bottom: 0;}
          }
        }
        .row-class {
          .box-item-attach{border-top: 1px solid #EAEAEA !important;border-left: 1px solid #EAEAEA !important; border-right: 1px solid #EAEAEA !important;padding: 8px 10px !important; position: relative;
            &:last-child{border-bottom: 1px solid #EAEAEA !important;}
            label{width: 100%; color: #343A40; font-size: 15px; margin-bottom: 0; display: block;
              .attach-left{ float: left;display: flex; align-items: center; width: calc(100% - 310px); min-height: 32px;
                img{ width: 16px; height: 16px;}
                span{padding-left: 10px;}
              }
              .attach-right{float:right; display: flex; align-items: center; position: relative; z-index: 100;
                .datetimepicker{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #838F9F; border-radius: 10px; height: 32px; margin-left: 10px; margin-right: 20px; color: #333333; font-size: 14px; padding: 0 10px;}
                span{font-size: 13px; font-weight: bold;}
              } 
              .remove{ z-index: 1000; font-size: 20px; position: absolute; right: 5px; top: 15px;}
            }
          }
        }
      }
    }
  }
  .box-footer{ margin-top: 32px;
    button{border-radius: 5px;width: 120px; height: 48px; border: 0 none;
      &.submit{background: #FFD311 0% 0% no-repeat padding-box; margin-right: 15px;}
      &.cancel{background: transparent;}
    }
  }
}
.custom-select2{
  .form-control{
    .select2-container{
      .selection{
        .custom-container{height: 100px !important; background: #f00 !important;}
      }
    }
  }
}
.select2-container{margin-top: 0 !important;
  .select2-selection--single{border-radius:10px !important; height:32px !important; display: block;
    .select2-selection__rendered{line-height: 30px !important;}
    .select2-selection__arrow{top: 3px;}
    .select2-selection__placeholder{color: #333;}
  }
  &.select2-container--open{
    .select2-selection--single{display: none;}
  }
  .custom-dropdown{background: #F2F2F2; border-radius: 10px;box-shadow: 0px 3px 6px #00000029; border: 1px solid #00000029;
    .select2-search{margin: 16px;padding:0; position: relative;
      &:after{content: "" ; color: #2759AE; background: url('../../../assets/images/faces/search.svg') 0 0 no-repeat;height: 16px; position: absolute; right: 12px; top: 8px; width: 16px;}
    }
    .select2-search__field{border-radius: 10px;position: relative; padding: 5px 30px 5px 10px;}
    .select2-results__option{padding: 5px 15px;
      &:last-child{border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;}
    }
  }
}
.custom-container{background-color: #F2F2F2;
}
.box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
.box-classes{
  input, select{border-radius: 10px;}
}

@media screen and (min-width: 768px){
  .vue-dialog {
    width: 500px !important;
  }
}
@media screen and (max-width: 991px){
  .box_header{
    label.title{display: block;}
  }
}
@media screen and (max-width: 768px){

}
@media screen and (max-width: 640px){
  .box_header{
    label.title{display: block;}
  }
  .box-content{
    .box-item{
      .box-item-child{margin-bottom: 10px;
        .item-img{width: 110px;}
        .item-info{ width: calc(100% - 135px);
          .info-categories{
            &.desktop{display: none;}
          }
          .info-grades{
            &.desktop{display: none;}
          }
        }
      }
      .info-categories{
        &.mobile{display: block;}
      }
      .info-grades{
        &.mobile{display: block;}
      }
    }
    .box-item-form{
      .inline-row{text-align: center;
        &.last-child{
          .control-label{display: none;}
        }
        button{width: 120px; margin-left: 10px;}
      }
    }
    .box-footer{ margin-top: 32px; text-align: center;
      button{border-radius: 5px;width: 120px; height: 48px; border: 0 none;}
    }
    .box-share{
      .item-share-content{
        .item-checkbox{
          input + label{width: 40px;}
        }
        .box-left {
          .row-class {
            .box-item-attach{
              label{
                .attach-left{ width: 100%;}
                .attach-right{ float: none; display: block; 
                  .datetimepicker{margin-right: 0; width: calc(100% - 90px);}
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// add.vue?5b63f6c4